import { render, staticRenderFns } from "./form-approve.vue?vue&type=template&id=52aff84d&scoped=true"
import script from "./form-approve.vue?vue&type=script&lang=js"
export * from "./form-approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aff84d",
  null
  
)

export default component.exports